import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LoginSectionSignInLightReverse1 from '../components/sign-in-light-reverse/LoginSectionSignInLightReverse1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Login() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <LoginSectionSignInLightReverse1 />
    </React.Fragment>
  );
}

